module.exports = __webpack_public_path__ + "static/mayank-cb68509f48e09a4270ac5c722d7bca6a.png";